import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { Modal } from "./Brands";

const empty = { name: "", status: "active" };

export default function Categories() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/categories").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (modal === "new") await api.post("/categories", form);
    else await api.patch(`/categories/${modal}`, form);
    setModal(null); load();
  };

  return (
    <Layout title="Categories" subtitle="Master"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => { setForm(empty); setModal("new"); }} data-testid="add-category-btn"><Plus size={14} /> Add category</button>}>
      <div className="card-sharp">
        <table className="fin">
          <thead><tr><th>Name</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`category-row-${c.id}`}>
                <td className="font-medium">{c.name}</td>
                <td><span className={`badge badge-${c.status}`}>{c.status}</span></td>
                <td className="text-right">
                  <button className="btn-outline mr-2" style={{padding:"6px 10px"}} onClick={() => { setForm(c); setModal(c.id); }}><Edit2 size={12} /></button>
                  <button className="btn-outline" style={{padding:"6px 10px"}} onClick={async () => { if (confirm("Delete category?")) { await api.delete(`/categories/${c.id}`); load(); } }}><Trash2 size={12} /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="3" className="text-center py-8 text-[#8C8C8C]">No categories yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal onClose={() => setModal(null)} title={modal === "new" ? "Add category" : "Edit category"}>
          <form onSubmit={save} className="space-y-4">
            <div><div className="label-tiny mb-1.5">Name</div><input className="fin" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="category-name" /></div>
            <div><div className="label-tiny mb-1.5">Status</div>
              <select className="fin" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                <option value="active">Active</option><option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="save-category-btn">Save</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
